import IHideSpinnerInPanelAction from "chrome/panel/duck/actions/interfaces/IHideSpinnerInPanelAction";
import PanelActionType from "chrome/panel/duck/actionTypes/panelActionType";

export default function hideSpinnerInPanel(): IHideSpinnerInPanelAction {
    return {
        type: PanelActionType.HIDE_SPINNER_IN_PANEL,
    };
}